import {Role} from "../../../modules/models";
import {maybeStr, requireNum, requireStr} from "../../../modules/utils";

class Pers {
    constructor(public guid: string, public firstName: string | null, public lastName: string | null) {}

    public static fromJson(json: any) {
        const guid = requireStr(json.guid);
        const firstName = maybeStr(json.firstName);
        const lastName = maybeStr(json.lastName);
        return new Pers(guid, firstName, lastName);
    }
}

class Location {
    constructor(public id: number, public description: string | null) {}

    public static fromJson(json: any) {
        const id = requireNum(json.id);
        const description = maybeStr(json.description);
        return new Location(id, description);
    }
}

class LocationAndRole {
    constructor(public role: Role, public location: Location) {}

    public static fromJson(json: any) {
        const role = Role.fromJson(json.role);
        const location = Location.fromJson(json.location);
        return new LocationAndRole(role, location);
    }
}

export class UserRoleReportRow {
    constructor(public person: Pers, public companyRoles: Role[], public locationRoles: LocationAndRole[]) { }

    static fromJson(json: any): UserRoleReportRow {
        const person = Pers.fromJson(json.person);
        const companyRoles = (json.companyRoles as any[]).map((cr) => Role.fromJson(cr.role));
        const locationRoles = (json.locationRoles as any[]).map((lr) => LocationAndRole.fromJson(lr));
        return new UserRoleReportRow(person, companyRoles, locationRoles);
    }
}
